<template>
  <b-autocomplete
    v-model="buffer.name"
    :data="filteredDisciplines"
    icon="hubzilla"
    v-validate="'required'"
    clearable
    :open-on-focus="true"
    placeholder="Discipline HCERES *"
    field="name"
    :loading="loading"
    :disabled="loading"
    @input="inputChanged"
    @select="selectDiscipline"
  >
    <template slot="empty">Aucune discipline trouvée</template>
  </b-autocomplete>
</template>

<script>
import coreService from '@/services/coreService'

export default {
  name: 'DisciplineInput',
  inject: ['$validator'],
  props: {
    value: {
      type: Object,
      default: function () {
        return {
          id: null,
          name: ''
        }
      }
    }
  },
  emits: ['input', 'onDisciplineChange'],
  data () {
    return {
      loading: true,
      disciplines: [],
      buffer: Object.assign({}, this.value)
    }
  },
  computed: {
    filteredDisciplines () {
      return this.disciplines.filter((option) => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.buffer.name.toLowerCase()) >= 0
        )
      })
    }
  },
  methods: {
    compare (disciplineA, disciplineB) {
      let comparison = 0
      if (disciplineA.name > disciplineB.name) {
        comparison = 1
      } else if (disciplineA.name < disciplineB.name) {
        comparison = -1
      }
      return comparison
    },
    selectDiscipline (option) {
      if (option) {
        this.buffer.id = option.id
        this.buffer.name = option.name
      }
    },
    inputChanged () {
      if (this.loading) {
        // ignore everything while the list of disciplines isn't fully loaded
        return
      }
      if (
        this.filteredDisciplines.length === 1 &&
        this.filteredDisciplines[0].name === this.buffer.name
      ) {
        this.buffer.id = this.filteredDisciplines[0].id
        this.buffer.name = this.filteredDisciplines[0].name
      } else {
        this.buffer.id = null
      }
      this.$emit('input', this.buffer)
      this.$emit('onDisciplineChange', this.buffer)
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Object.assign({}, this.value)
      },
      deep: true
    }
  },
  created () {
    coreService.getDisciplines().then((data) => {
      this.disciplines = data
      // this will make sure the list of disciplines is loaded prior to anything
      // else. Since this is run in the background, there's might be a race
      // condition because the parent (MyLaboratory) fill in the saved
      // discipline in the input triggering a call to the inputChanged method.
      // If called too early this method will find no corresponding discipline
      // and will set the id to null (this will be interpreted as an error in
      // the parent component)
      this.loading = false
    })
  }
}
</script>
